import axios from "axios";
import { ReportFilter } from "../models/Report/ReportFilter";
import saveAs from "file-saver";
import { AuthUtil } from "../utils/AuthUtil";

const downlodReport = async (
    filterdata:ReportFilter, 
    successCallback: (success: any) => void,
    errorCallback: (error: Error) => void
  ) => {
    //var formData = new FormData();
     //   formData.append('fileId', attchement.uploadFileId.toString());
    
        let url = process.env.REACT_APP_BASE_URL + "Report/GetExcelStream";
        //let tempFiles = clientConfiguration[`tempFiles.${env}`];
        //alert(tempFiles);
    
        axios({
           // headers: {'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
            //    ,'authorization' : `Bearer ${AuthUtil.getAuthHeaderTocken()}`
           // },
             headers: { 'x-api-key' : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
                ,'authorization' : `Bearer ${AuthUtil.getAuthHeaderTocken()}`
            },
           
            method: 'post',
            responseType: 'arraybuffer', //Force to receive data in a Blob Format
            url: url,
            data: filterdata
        })
            .then(res => {
               
                let fileName = "report.xlsx";
               //let fileName = attchement.displayFileName;
    
               const blob = new Blob([res.data], {
                    type: 'application/octet-stream'
                });
    
                saveAs(blob, fileName);
                console.log(res);
                successCallback(true);
            })
            .catch(error => {
                console.log(error.message);
                errorCallback(error)
            });
  };

export const ReportService = {
    downlodReport
  };